import { t } from "@lingui/macro";
import StatsTooltipRow from "components/StatsTooltip/StatsTooltipRow";
import { ProcessedData } from "lib/legacy";
import { formatKeyAmount } from "lib/numbers";

type Props = {
  processedData?: ProcessedData;
  nativeTokenSymbol: string;
  isUserConnected?: boolean;
};

function renderEscrowedMONEYApr(processedData) {
  if (!processedData?.moneyAprForEsMoney || processedData.moneyAprForEsMoney <= 0) return;
  return (
    <StatsTooltipRow
      label={t`Escrowed MONEY APR`}
      showDollar={false}
      value={`${formatKeyAmount(processedData, "moneyAprForEsMoney", 2, 2, true)}%`}
    />
  );
}

export default function MONEYAprTooltip({ processedData, nativeTokenSymbol, isUserConnected = false }: Props) {
  const escrowedMONEYApr = renderEscrowedMONEYApr(processedData);
  const moneyAprForNativeTokenPercentage = formatKeyAmount(processedData, "moneyAprForNativeToken", 2, 2, true);
  const moneyAprForMoneyPercentage = formatKeyAmount(processedData, "moneyAprForMoney", 2, 2, true);

  const shouldShowNativeTokenApr = processedData?.moneyAprForNativeToken && processedData.moneyAprForNativeToken > 0;

  const aprUpdateMsg = t`APRs are updated weekly on Wednesday and will depend on the fees collected for the week.`;

  return (
    <>
      <div>
        <StatsTooltipRow label={t`MONEY APR`} showDollar={false} value={`${moneyAprForMoneyPercentage}%`} />
        {isUserConnected && escrowedMONEYApr && (
          <>
            <br /> {escrowedMONEYApr}
          </>
        )}
        {shouldShowNativeTokenApr ? (
          <StatsTooltipRow
            label={t`${nativeTokenSymbol} APR`}
            showDollar={false}
            value={`${moneyAprForNativeTokenPercentage}%`}
          />
        ) : null}
      </div>
      <div>
        <br />
        {aprUpdateMsg}
      </div>
    </>
  );
}
